import { isSignInWithEmailLink } from "firebase/auth";
import { useSearchParams } from "react-router";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { PasswordlessSignin } from "./PasswordlessSignin";
import { ResetPassword } from "./ResetPassword";

export function FirebaseHandler() {
  const [searchParams] = useSearchParams();
  const { mode, oobCode } = Object.fromEntries(searchParams);

  const { auth } = useFirebaseUser();

  if (isSignInWithEmailLink(auth, window.location.href)) {
    return <PasswordlessSignin />;
  }

  switch (mode) {
    case "resetPassword": {
      if (!oobCode) throw new Error("Cannot find oobCode");
      return <ResetPassword oobCode={oobCode} />;
    }
    default:
      throw new Error(`Unknown firebase handler mode: ${mode}`);
  }
}
